<template>
  <!-- 查荣誉证书 -->
  <div style="margin-top: 120px;">
    <search-nav :active="3"></search-nav>
    <!-- <el-affix :offset="120"> -->
      <el-row>
        <div class="container">
          <!--输入框-->
          <el-row style="margin-bottom: 30px">
            <el-col :span="13">
              <div>
                <el-autocomplete
                  style="width: 100%"
                  clearable
                  class="inline-input"
                  v-model="conditions.keyword"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入荣誉证书关键词"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                  size="medium"
                  input-style="border-bottom-right-radius:0px;border-top-right-radius:0px;height:50px"
                >
                </el-autocomplete>
              </div>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" style="background: #FC7A1E;border-color: #FC7A1E;" class="search-btn-search" @click="handleSearchList" size="medium">查询</el-button>
            </el-col>
          </el-row>
        </div>
      </el-row>
    <!-- </el-affix> -->
    <el-row>
      <div class="container">
        <!--筛选条件-->
        <div style="margin-bottom: 30px" class="condition-content">
          <div class="dis-bet-cen condition-title">
            <span class="screening-conditions-title" style="font-size: 16px;color: #666666;">筛选条件</span>
            <link-to-advanced></link-to-advanced>
          </div>
          <div style="padding: 15px 0 20px 0;">
          <el-row v-if="tags.length > 0" class="dis-cen-cen">
            <el-col :span="2"><div class="grid-content bg-purple" style="font-size: 14px;color: #5D6FE9;">已选条件：</div></el-col>
            <el-col :span="20">
              <div class="grid-content bg-purple dis-sta-cen" >
                <el-tag style="margin-right: 10px" v-for="(tag, index) in tags" :key="tag.name" closable :type="tag.type" @close="closeTag(tag, index)">
                  {{tag.name}}
                </el-tag>
              </div>
            </el-col>
            <el-col :span="2">
              <div @click="closeAllTag" class="grid-content bg-purple font-choose-text">清除全部</div>
            </el-col>
          </el-row>
          <el-row v-if="!conditions.honorType" class="dis-cen-cen ">
            <el-col :span="2"><div class="grid-content bg-purple" style="font-size: 14px;color: #999999;">荣誉类型：</div></el-col>
            <el-col :span="22">
              <el-row>
                <el-col :span="2" >
                  <el-button type="text" style="float: left;" @click="honorTypeClick('1')"><p style="font-size: 14px;color: #666666;">行业荣誉</p></el-button>
                </el-col>
                <el-col :span="2" style="float: left; margin: 0px 0px 0px 10px;">
                  <el-button type="text" style="float: left;" @click="honorTypeClick('2')"><p style="font-size: 14px;color: #666666;">工商荣誉</p></el-button>
                </el-col>
                <el-col :span="2" style="float: left; margin: 0px 0px 0px 10px;">
                  <el-button type="text" style="float: left;" @click="honorTypeClick('3')"><p style="font-size: 14px;color: #666666;">税务荣誉</p></el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row v-if="(!conditions.relevancyIdArr || conditions.relevancyIdArr.length === 0) && (conditions.honorType == '1' || conditions.honorType == '2')" class="dis-cen-cen" style="margin-top: 10px;">
            <el-col :span="2"><div class="grid-content bg-purple" style="font-size: 14px;color: #999999;">荣誉分类：</div></el-col>
            <el-col :span="22">
              <el-row>
                <el-col :span="13" >
                  <div v-if="clearForm">
                    <el-cascader
                      ref="cascader"
                      clearable
                      collapse-tags
                      separator=">"
                      filterable="true"
                      placeholder="请选择荣誉分类"
                      style="width: 100%;"
                      v-model="cascaderValue"
                      size="medium"
                      :options="cascaderOptions"
                      :props="cascaderProps"
                      @change="cascaderHandleChange"></el-cascader>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row v-if="!conditions.companyKeyword" class="dis-cen-cen already-choose">
            <el-col :span="2"><div class="grid-content bg-purple" style="font-size: 14px;color: #999999;">企业名称：</div></el-col>
            <el-col :span="22">
              <el-row class="dis-sta-cen">
                <el-col :span="13">
                  <div>
                    <el-input v-model="companyKeyword" placeholder="请输入企业名称关键词" size="medium" clearable></el-input>
                  </div>
                </el-col>
                <el-col :span="4">
                  <el-button type="" style="float: left;margin-left: 10px;"  size="medium" @click="companyKeywordClick">确定</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row v-if="!conditions.issueData || conditions.issueData.length  === 0" class="dis-cen-cen already-choose">
            <el-col :span="2"><div class="grid-content bg-purple" style="font-size: 14px;color: #999999;">获奖时间：</div></el-col>
            <el-col :span="22" class="dis-sta-cen">
              <date-picker-year @handleResule="handleDatePick"></date-picker-year>
            </el-col>
          </el-row>
          <el-row class="dis-cen-cen already-choose">
            <el-col :span="2">
              <div class="grid-content bg-purple" >
                <el-button type="primary" @click="queryList()" size="medium">查询</el-button>
              </div>
            </el-col>
          </el-row>
          </div>
        </div>
        <!--内容卡片 柏成大佬-->
        <el-row style="margin-top: 30px;margin-bottom: 30px">
          <el-col :span="24">
            <div class="condition-content">
              <div class="dis-bet-cen condition-title">
                <span class="screening-conditions-title">共查询到 <span class="font-color-red">{{ page.total }}</span> 条符合条件的荣誉</span>
                <span class="advanced-query-title">
                <el-select v-model="optionsValue" @change="handleSelsect" placeholder="默认排序">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </span>
              </div>
              <div class="condition-content-list" v-if="queryConditions.honorType == '1' || queryConditions.honorType == '2'">
                <!--荣誉-->
                <block v-show="!fuzzyDataShow" v-for="(item, index) of dataList" :key="index">
                  <el-row class="list-padding list-hover">
                    <el-col :span="24">
                      <div class="condition-content-list-name dis-bet-cen">
                        <span v-html="item.name"></span>
                        <span v-if="item.isfocus == '4'">
                      <el-tooltip class="item" effect="dark" content="用户提供了完整的资料数据，但无法在公开网站上核验" placement="bottom-end">
                        <span class="focus-enterprises-tag-yellow">未核验</span>
                      </el-tooltip>
                    </span>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <el-row :gutter="20" class="condition-content-list-title">
                        <el-col :span="10">企业名称：<span class="font-color-gray" style="cursor:pointer" @click="companyNameClick(item, index)">{{item.companyName || '-'}}</span></el-col>
                        <el-col :span="10">发证日期：<span class="font-color-gray">{{item.issueData || '-'}}</span></el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-divider v-if="(index + 1) != dataList.length"></el-divider>
                </block>
                <el-empty v-if="dataList.length === 0"  :image-size="200"></el-empty>
                <gaussian-blur pageName="company-achievement" v-show="fuzzyDataShow"></gaussian-blur>
              </div>
              <div class="condition-content-list" v-if="queryConditions.honorType == '3'">
                <!--税务荣誉-->
                <block v-show="!fuzzyDataShow" v-for="(item, index) of dataList" :key="index">
                  <el-row class="list-padding list-hover">
                    <el-col :span="24">
                      <div class="condition-content-list-name dis-bet-cen">
                        <span>纳税信用等级:{{item.level}}</span>
                        <span v-if="item.isfocus == '4'">
                          <el-tooltip class="item" effect="dark" content="用户提供了完整的资料数据，但无法在公开网站上核验" placement="bottom-end">
                            <span  class="focus-enterprises-tag-yellow">未核验</span>
                          </el-tooltip>
                        </span>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <el-row :gutter="20" class="condition-content-list-title">
                        <el-col :span="7">企业名称：<span class="font-color-gray" style="cursor:pointer" @click="companyNameClick(item, index)" v-html="item.companyName "></span></el-col>
                        <el-col :span="7">评价年度：<span class="font-color-gray">{{item.year || '-'}}</span></el-col>
                        <el-col :span="7">纳税人识别号：<span class="font-color-gray">{{item.no || '-'}}</span></el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-divider v-if="(index + 1) != dataList.length"></el-divider>
                </block>
                <el-empty v-if="dataList.length === 0"  :image-size="200"></el-empty>
                <gaussian-blur pageName="company-achievement" v-show="fuzzyDataShow"></gaussian-blur>
              </div>
            </div>
          </el-col>
        </el-row>
        <!--分页组件-->
        <div class="dis-end-sta" style="margin-bottom: 30px">
          <el-pagination
            :hide-on-single-page="true"
            :pager-count="page.pagerCount"
            background
            layout="prev, pager, next"
            @current-change="currentChange"
            v-model:currentPage="page.pageNum"
            :total="page.total">
          </el-pagination>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import { parseTime } from '@/utils/index' // 工具类
import { ElMessage } from 'element-plus'
import SearchNav from '@/components/search-nav/search-nav'
import LinkToAdvanced from '@/components/link-to-advanced/link-to-advanced'
import DatePickerYear from '@/components/date-picker-year/date-picker-year'
import { forwardBG, oldForwardBG } from '@/api/forward.js'
import { getMatchingAllMayHonorRelevancy } from '@/api/query.js'
import { mapGetters } from 'vuex'
import GaussianBlur from '@/components/gaussian-blur/gaussian-blur'
import toFixs from '@/utils/toDate'
export default {
  name: 'company-honor-image',
  components: {
    SearchNav,
    LinkToAdvanced,
    DatePickerYear,
    GaussianBlur
  },
  setup (props, context) {
    function loginEmit () {
      context.emit('loginEmit', 'topNav')
    }
    return {
      loginEmit
    }
  },
  data () {
    return {
      companyKeyword: '', // 企业名称关键字
      conditions: {
        keyword: this.$route.query.searchVal ? this.$route.query.searchVal : '', // 查询的关键字
        honorType: '', // 荣誉类型 1: 行业荣誉 2:工商荣誉 3:税务荣誉
        companyKeyword: '', // 已经选择的企业名称
        issueData: [], // 已经选择的中标时间 格式 ["2021-11-30T16:00:00.000Z","2022-05-31T16:00:00.000Z"]
        relevancyIdArr: [] // 荣誉分类
      },
      queryConditions: {
        keyword: '', // 查询的关键字
        honorType: '1', // 荣誉类型 1: 行业荣誉 2:工商荣誉 3:税务荣誉
        companyKeyword: '', // 已经选择的企业名称
        issueData: [], // 已经选择的中标时间 格式 ["2021-11-30T16:00:00.000Z","2022-05-31T16:00:00.000Z"]
        relevancyIdArr: [], // 荣誉分类
        orderType: ''
      },
      // 数据
      dataList: [],
      clearForm: true,
      totalCascaderList: [],
      cascaderValue: [],
      cascaderOptions: [],
      cascaderProps: { multiple: false, expandTrigger: 'hover' },
      // 排序的筛选 如果是税务荣誉按照评价年度排序
      optionsValue: '0',
      options: [{
        value: '0',
        label: '默认排序',
        orderType: ''
      }, {
        value: '1',
        label: '发证日期升序',
        orderType: 'asc'
      }, {
        value: '2',
        label: '发证日期降序',
        orderType: 'desc'
      }],
      tags: [],
      page: { // 分页使用
        total: 0, // 总条数
        pagerCount: 7,
        pageNum: 1
      },
      returnLimit: false, // 返回数据是否受限
      fuzzyDataShow: false, // 模糊图片是否显示
      fuzzyData: require('@/assets/images/fuzzy_data.png')
    }
  },
  computed: {
    ...mapGetters([
      'vipData', // 会员数据
      'idToken'
    ]),
    vipLevelChange: function () {
      const vm = this
      // console.log('计算属性: ' + JSON.parse(vm.vipData).vipLevel)
      if (vm.vipData && JSON.parse(vm.vipData)) {
        return JSON.parse(vm.vipData).vipLevel
      } else {
        return null
      }
    }
  },
  watch: {
    vipLevelChange: function (newValue, oldValue) {
      const vm = this
      const data = {
        type: 1
      }
      vm.getAllhonor(data)
      vm.handleSearchList()
    },
    honorTypeStr: {
      handler (val, oldval) {
        if (val) {
          this.closeAllTag()
        }
      }
    },
    idToken: {
      handler (val, oldval) {
        this.handleSearchList()
      }
    }
  },
  mounted () {
    const vm = this
    const data = {
      type: 1
    }
    vm.getAllhonor(data)
    vm.handleSearchList()
  },
  methods: {
    // 输入框输入内容触发
    querySearch (queryString, callback) {
      const arr = []
      callback(arr)
    },
    // 输入框选择之后返回的数据
    handleSelect (item) {
      console.log(item)
    },
    // 选择荣誉类型触发
    honorTypeClick (val) {
      const vm = this
      const obj = val
      let honorTypeStr = ''
      if (obj === '1') {
        honorTypeStr = '行业荣誉'
        const data = {
          type: obj
        }
        vm.getAllhonor(data)
      }
      if (obj === '2') {
        honorTypeStr = '工商荣誉'
        const data = {
          type: obj
        }
        vm.getAllhonor(data)
      }
      if (obj === '3') honorTypeStr = '税务荣誉'
      vm.conditions.honorType = obj
      vm.tags.push({
        name: '荣誉类型：' + honorTypeStr,
        value: 'honorType',
        default: ''
      })
    },
    getAllhonor (data) {
      const vm = this
      getMatchingAllMayHonorRelevancy(data).then(result => {
        console.log(result)
        if (result.code === 0) {
          const res = result.data
          vm.totalCascaderList = res
          vm.getRelevancyList(res, '0', function (a) {
            console.log(a)
            vm.cascaderOptions = a
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getRelevancyList: function (data, parentId, callback) {
      const arr = []
      const vm = this
      data.forEach((item, index) => {
        let obj = {}
        if (item.parentId === parentId) {
          obj = {
            value: item.id,
            label: item.name,
            parentId: item.parentId
          }
          if (vm.getRelevancyListChild(data, item, item.id).length > 0) {
            obj.children = vm.getRelevancyListChild(data, item, item.id)
          }
          arr.push(obj)
        }
      })
      callback(arr)
    },
    getRelevancyListChild: function (arr, parentItem, parentId) {
      const vm = this
      const arrs = []
      arr.forEach((item, index) => {
        let obj = {}
        if (item.parentId === parentId) {
          if (vm.getRelevancyListChild(arr, item, item.id).length > 0) {
            obj = {
              value: item.id,
              label: item.name,
              parentId: item.parentId,
              children: vm.getRelevancyListChild(arr, item, item.id)
            }
          } else {
            obj = {
              value: item.id,
              label: item.name,
              parentId: item.parentId
            }
          }
          arrs.push(obj)
        }
      })
      return arrs
    },
    // 多级下拉的回调
    cascaderHandleChange (item) {
      const vm = this
      console.log(item)
      const n = item.length - 1
      for (let i = 0; i < vm.totalCascaderList.length; i++) {
        if (vm.totalCascaderList[i].id === item[n]) {
          const obj = {
            name: vm.totalCascaderList[i].name,
            id: item[n]
          }
          vm.conditions.relevancyIdArr.push(obj)
          break
        }
      }
      const relevancyNameArr = vm.treeToLabel(vm.cascaderOptions, item)
      // 清理选中项
      vm.cascaderValue = []
      vm.tags.push({
        name: '荣誉类型：' + relevancyNameArr,
        value: 'relevancyIdArr',
        default: []
      })
    },
    treeToLabel (data, arr) {
      const result = []
      const childrenTreeToLabel = (data, arr, result) => {
        for (let j = 0; j < data.length; j++) {
          if (arr[0] === data[j].value) {
            result.push(data[j].label)
            if (data[j].children && arr.length > 1) {
              childrenTreeToLabel(data[j].children, arr.slice(1), result)
            }
            break
          }
        }
      }
      childrenTreeToLabel(data, arr, result)
      return result.join('>')
    },
    // 选择时间触发 ["2021-11-30T16:00:00.000Z","2022-10-31T16:00:00.000Z"]
    handleDatePick (item) {
      console.log(item)
      const vm = this
      vm.conditions.issueData = item
      if (vm.conditions.issueData) {
        vm.tags.push({
          name: '获奖时间：' + vm.conditions.issueData[0] + '年-' + vm.conditions.issueData[1] + '年',
          value: 'issueData',
          default: ''
        })
      }
    },
    issueDataChange () {
      const vm = this
      console.log(vm.conditions.issueData)
      if (vm.conditions.issueData) {
        vm.tags.push({
          name: '获奖时间：' + parseTime(vm.conditions.issueData[0], '{y}年{m}月') + '-' + parseTime(vm.conditions.issueData[1], '{y}年{m}月'),
          value: 'issueData',
          default: ''
        })
      }
    },
    // 企业名称的确定按钮
    companyKeywordClick () {
      const vm = this
      if (vm.companyKeyword) {
        vm.conditions.companyKeyword = vm.companyKeyword
        vm.companyKeyword = ''
        vm.tags.push({
          name: '企业名称：' + vm.conditions.companyKeyword,
          value: 'companyKeyword',
          default: ''
        })
      } else {
        return ElMessage.warning({
          message: '请先输入企业名称关键字',
          type: 'warning',
          offset: 60
        })
      }
    },
    // 关闭Tag触发
    closeTag (item, index) {
      const vm = this
      if (item.value === 'honorType') {
        vm.closeAllTag()
      }
      vm.tags.splice(index, 1)
      vm.conditions[item.value] = item.default
    },
    // 清除全部Tag
    closeAllTag () {
      const vm = this
      vm.tags = []
      vm.conditions.honorType = ''
      vm.conditions.companyKeyword = ''
      vm.conditions.issueData = []
      vm.conditions.relevancyIdArr = []
      vm.queryConditions.orderType = ''
    },
    // 翻页时触发
    currentChange (cuttentPage) {
      const vm = this
      if (vm.idToken) {
        if (vm.returnLimit) { // 已经返回受限了 就不继续查询了
          vm.page.pageNum = -Math.ceil(Math.random() * 1000)
          vm.fuzzyDataShow = true
        } else {
          document.documentElement.scrollTop = 0
          vm.page.pageNum = cuttentPage
          vm.getList()
        }
      } else {
        vm.page.pageNum = -Math.ceil(Math.random() * 1000)
        vm.loginEmit()
      }
    },
    // 点击查询触发
    handleSearchList: function () {
      const vm = this
      // 如果跟上次查询的不一样就清理下面
      if (vm.oldKeyword !== vm.conditions.keyword) {
        vm.closeAllTag()
        vm.queryConditions.honorType = '1'
        vm.queryConditions.companyKeyword = ''
        vm.queryConditions.issueData = []
        vm.queryConditions.relevancyIdArr = []
      }
      vm.oldKeyword = vm.conditions.keyword
      vm.queryConditions.keyword = vm.conditions.keyword
      vm.page.pageNum = 1
      // 去查询
      vm.getList()
    },
    // 选则排序触发
    handleSelsect: function (e) {
      const vm = this
      if (vm.idToken) {
        if (vm.returnLimit) { // 已经返回受限了 就不继续查询了
          vm.page.pageNum = -Math.ceil(Math.random() * 1000)
          vm.fuzzyDataShow = true
        } else {
          vm.page.pageNum = 1
          vm.queryConditions.orderType = vm.options[e].orderType
          vm.getList()
        }
      } else {
        vm.optionsValue = '0'
        vm.loginEmit()
      }
    },
    queryList: function () {
      const vm = this
      if (vm.idToken) {
        if (vm.returnLimit) { // 已经返回受限了 就不继续查询了
          vm.page.pageNum = -Math.ceil(Math.random() * 1000)
          vm.fuzzyDataShow = true
        } else {
          vm.page.pageNum = 1
          vm.queryConditions.honorType = vm.conditions.honorType ? vm.conditions.honorType : '1'
          vm.queryConditions.companyKeyword = vm.conditions.companyKeyword
          vm.queryConditions.relevancyIdArr = vm.conditions.relevancyIdArr
          vm.queryConditions.issueData = vm.conditions.issueData
          vm.getList()
        }
      } else {
        vm.loginEmit()
      }
    },
    getList: function () {
      const vm = this
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        dateBackgroundUrl: vm.idToken ? '/esHonor/getESHonorListByModel' : '/esFake/esHonor/getESHonorListByModel',
        dateBackgroundRequestType: 'GET',
        data: {
          companyName: vm.queryConditions.companyKeyword ? vm.queryConditions.companyKeyword.trim() : null,
          honorNameArr: vm.queryConditions.relevancyIdArr.length > 0 ? vm.queryConditions.relevancyIdArr[0].name : null,
          honorType: vm.queryConditions.honorType ? vm.queryConditions.honorType : null,
          issueDataEnd: vm.queryConditions.issueData.length > 0 ? vm.queryConditions.issueData[1] : null,
          issueDataStart: vm.queryConditions.issueData.length > 0 ? vm.queryConditions.issueData[0] : null,
          name: vm.queryConditions.keyword ? vm.queryConditions.keyword.trim() : null,
          pageNum: vm.page.pageNum,
          pageSize: 10,
          orderType: vm.queryConditions.orderType === '' ? null : vm.queryConditions.orderType,
          orderField: vm.queryConditions.orderType === '' ? null : 'issue_date_order'
        }
      }
      const forward = vm.idToken ? oldForwardBG : forwardBG
      forward(data).then(result => {
        if (result.code === 0 || result.code === 97 || result.code === 98) {
          if (result.code === 97) {
            vm.returnLimit = true
            vm.fuzzyDataShow = false
          } else if (result.code === 98) {
            vm.returnLimit = true
            vm.fuzzyDataShow = true
          } else {
            vm.returnLimit = false
            vm.fuzzyDataShow = false
          }
          const res = result.data
          console.log(res)
          const arr = []
          const companyIds = []
          if (res.length > 0) {
            if (vm.queryConditions.honorType === '1' || vm.queryConditions.honorType === '2') {
              res.forEach((item, index) => {
                vm.page.total = item.dataTotal
                const obj = {
                  id: item.id,
                  companyId: item.companyId,
                  companyName: vm.returnLimit || !vm.idToken ? toFixs.getcompanyName(item.companyName) : item.companyName,
                  honorName: item.honorName === null || item.honorName === 'null' ? '-' : item.honorName,
                  issueData: item.issueData === null || item.issueData === 'null' || item.issueData === '' ? '-' : item.issueData,
                  name: item.name === null || item.name === 'null' ? '-' : item.name
                }
                companyIds.push(item.id)
                arr.push(obj)
              })
            } else {
              res.forEach((item, index) => {
                vm.page.total = item.dataTotal
                const obj = {
                  id: item.id,
                  companyId: item.companyId,
                  companyName: vm.returnLimit || !vm.idToken ? toFixs.getcompanyName(item.companyName) : item.companyName,
                  honorName: item.honorName === null || item.honorName === 'null' ? '-' : item.honorName,
                  issueData: item.issueData === null || item.issueData === 'null' || item.issueData === '' ? '-' : item.issueData,
                  name: item.name === null || item.name === 'null' ? '-' : item.name,
                  year: item.year === null || item.year === 'null' ? '-' : item.year,
                  no: item.no === null || item.no === 'null' ? '-' : item.no,
                  level: item.level === null || item.level === 'null' ? '-' : item.level
                }
                companyIds.push(item.id)
                arr.push(obj)
              })
            }
            loading.close()
          } else {
            loading.close()
            vm.page.total = 0
          }
          vm.dataList = arr
        } else {
          loading.close()
        }
      }).catch(error => {
        loading.close()
        console.log(error)
      })
    },
    // 点击了 公司名 跳转到公司详情
    companyNameClick (item, index) {
      const vm = this
      vm.$store.dispatch('setBusId', item.companyId)
      vm.$router.push({ name: 'enterprise-details' })
    }
  }
}
</script>

<style scoped="scoped">
.already-choose{
   margin-top: 10px
 }
.input-search {
  margin-top: 120px;
}
/deep/ .el-input-group__append, .el-input-group__prepend {
  background-color: #5D6FE9;
  border: none;
  color: #fff;
  width: 70px;
}
.conditions-font-title {
  font-size: 14px;
  color: #999;
  display: block;
  height: 40px;
  line-height: 40px;
}
.focus-enterprises-tag {
  position: absolute;
  top: 50%;
  right: 20px;
  height: 30px;
  margin-top: -17px;
  border: 1px solid #5D6FE9;
  color: #5D6FE9;
  line-height: 30px;
  padding: 0 5px;
  font-size: 14px;
  cursor: pointer;
}
.focus-enterprises-tag-gray {
  position: absolute;
  top: 50%;
  right: 20px;
  height: 30px;
  margin-top: -17px;
  border: 1px solid #E6E6E6;
  color: #666;
  line-height: 30px;
  padding: 0 5px;
  font-size: 14px;
  cursor: pointer;
}
.focus-enterprises-tag-yellow {
  color: #EA9920;
  padding: 0 5px;
  border: 1px solid #EA9920;
  cursor: pointer;
  font-size: 12px;
  margin-left: 10px;
}
.list-hover:hover{
  background-color: #F3F9FD;
}
.el-divider--horizontal {
  margin: 0;
}
/deep/ .el-input.el-input--medium.el-input--suffix {
  line-height: 50px !important;
}
</style>
